export const PRIMARY = 'PRIMARY';
export const SECONDARY = 'SECONDARY';
export const TERTIARY = 'TERTIARY';
export const QUATERNARY = 'QUATERNARY';
export const QUINARY = 'QUINARY';
export const UTILITY1 = 'UTILITY1';
export const UTILITY2 = 'UTILITY2';
export const UTILITY3 = 'UTILITY3';
export const UTILITY4 = 'UTILITY4';
export const ECO = 'ECO';
export const LIVE = 'LIVE';
export const HIGHLIGHT = 'HIGHLIGHT';
export const CLOUD_DARK = 'CLOUD_DARK';
export const CLOUD_NORMAL = 'CLOUD_NORMAL';
export const CLOUD_WHITE = 'CLOUD_WHITE';

export const colorNames = [
  PRIMARY,
  SECONDARY,
  TERTIARY,
  QUATERNARY,
  QUINARY,
  UTILITY1,
  UTILITY2,
  UTILITY3,
  UTILITY4,
  ECO,
  LIVE,
  HIGHLIGHT,
  CLOUD_WHITE,
  CLOUD_NORMAL,
  CLOUD_DARK,
];
